export default __webpack_public_path__ + "static/media/studio.7b173db8.svg";